import { StepCard } from '../../StepCard';

export const content = ({ step }) => step?.description;

export const getDescription = () => {
  return '';
};

export default function LoopNextCard({ step, ...others }) {
  return <StepCard {...others}>{content({ step })}</StepCard>;
}
